import React from 'react'
import { DASHBOARD_URLS } from './services/dashboardService'
import type { WidgetDefinition, WidgetKey } from './types'
const DossiersByStatusWidget = React.lazy(() =>
  import('./widgets/admin/DossiersByStatusWidget').then((m) => ({
    default: m.DossiersByStatusWidget,
  }))
)
const OverviewKpisWidget = React.lazy(() =>
  import('./widgets/admin/OverviewKpisWidget').then((m) => ({ default: m.OverviewKpisWidget }))
)
const DocumentsByMonthWidget = React.lazy(() =>
  import('./widgets/admin/DocumentsByMonthWidget').then((m) => ({
    default: m.DocumentsByMonthWidget,
  }))
)

const MyDossierTypesWidget = React.lazy(() =>
  import('./widgets/guest/MyDossierTypesWidget').then((m) => ({ default: m.MyDossierTypesWidget }))
)
const SignerKpiSummaryWidget = React.lazy(() =>
  import('./widgets/signer/SignerKpiSummaryWidget').then((m) => ({
    default: m.SignerKpiSummaryWidget,
  }))
)
const MyDossiersByStatusWidget = React.lazy(() =>
  import('./widgets/guest/MyDossiersByStatusWidget').then((m) => ({
    default: m.MyDossiersByStatusWidget,
  }))
)
const OutboxStatusWidget = React.lazy(() =>
  import('./widgets/admin/OutboxStatusWidget').then((m) => ({ default: m.OutboxStatusWidget }))
)
const TrustedCaExpiryWidget = React.lazy(() =>
  import('./widgets/admin/TrustedCaExpiryWidget').then((m) => ({
    default: m.TrustedCaExpiryWidget,
  }))
)
const SignActivityWidget = React.lazy(() =>
  import('./widgets/signer/SignActivityWidget').then((m) => ({ default: m.SignActivityWidget }))
)
const IssueWaitingAgeWidget = React.lazy(() =>
  import('./widgets/admin/IssueWaitingAgeWidget').then((m) => ({
    default: m.IssueWaitingAgeWidget,
  }))
)
const IssuedByDossierTypeWidget = React.lazy(() =>
  import('./widgets/admin/IssuedByDossierTypeWidget').then((m) => ({
    default: m.IssuedByDossierTypeWidget,
  }))
)
const IssuedByWeekWidget = React.lazy(() =>
  import('./widgets/admin/IssuedByWeekWidget').then((m) => ({ default: m.IssuedByWeekWidget }))
)

export const WIDGET_REGISTRY: Record<WidgetKey, WidgetDefinition> = {
  'overview-kpis': {
    key: 'overview-kpis',
    endpoint: DASHBOARD_URLS.overviewKpis,
    title: 'Tổng quan hệ thống',
    group: 'admin',
    component: OverviewKpisWidget,
    colSpan: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
  },
  'documents-by-month': {
    key: 'documents-by-month',
    endpoint: DASHBOARD_URLS.documentsByMonth,
    title: 'Số lượng tài liệu 12 tháng gần nhất',
    group: 'admin',
    component: DocumentsByMonthWidget,
    colSpan: { xs: 24, sm: 24, md: 12, lg: 16, xl: 16 },
  },
  'dossiers-by-status': {
    key: 'dossiers-by-status',
    endpoint: DASHBOARD_URLS.dossiersByStatus,
    title: 'Tiến độ hồ sơ (Phễu xử lý)',
    group: 'admin',
    component: DossiersByStatusWidget,
    colSpan: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 },
  },
  'my-dossiers': {
    key: 'my-dossiers',
    endpoint: DASHBOARD_URLS.myDossiers,
    title: 'Hồ sơ của tôi theo trạng thái',
    group: 'guest',
    component: MyDossiersByStatusWidget,
    colSpan: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
  },
  'outbox-status': {
    key: 'outbox-status',
    endpoint: DASHBOARD_URLS.outboxStatus,
    title: 'Hàng đợi email (7 ngày)',
    group: 'admin',
    component: OutboxStatusWidget,
    colSpan: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
  },
  'trusted-ca-expiry': {
    key: 'trusted-ca-expiry',
    endpoint: DASHBOARD_URLS.trustedCaExpiry,
    title: 'CA tin cậy theo hạn',
    group: 'admin',
    component: TrustedCaExpiryWidget,
    colSpan: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
  },
  'my-sign-activity': {
    key: 'my-sign-activity',
    endpoint: DASHBOARD_URLS.mySignActivity,
    title: 'Ký số theo tuần của tôi',
    group: 'signer',
    component: SignActivityWidget,
    colSpan: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
  },
  'issue-waiting-age': {
    key: 'issue-waiting-age',
    endpoint: DASHBOARD_URLS.issueWaitingAge,
    title: 'Hồ sơ chờ phát hành theo thời gian chờ',
    group: 'admin',
    component: IssueWaitingAgeWidget,
    colSpan: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
  },
  'issued-by-dossier-type': {
    key: 'issued-by-dossier-type',
    endpoint: DASHBOARD_URLS.issuedByDossierType,
    title: 'Hồ sơ đã phát hành theo loại (30 ngày)',
    group: 'admin',
    component: IssuedByDossierTypeWidget,
    colSpan: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
  },
  'issued-by-week': {
    key: 'issued-by-week',
    endpoint: DASHBOARD_URLS.issuedByWeek,
    title: 'Hồ sơ phát hành theo tuần',
    group: 'admin',
    component: IssuedByWeekWidget,
    colSpan: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
  },
  'my-pending-signatures': {
    key: 'my-pending-signatures',
    endpoint: DASHBOARD_URLS.myPendingSignatures,
    title: 'Tài liệu chờ tôi ký duyệt',
    group: 'signer',
    component: SignerKpiSummaryWidget,
    colSpan: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
  },
  'my-documents': {
    key: 'my-documents',
    endpoint: DASHBOARD_URLS.myDocuments,
    title: 'Hồ sơ của tôi theo loại',
    group: 'guest',
    component: MyDossierTypesWidget,
    colSpan: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
  },
}
